import * as SubframeCore from "@subframe/core";
import { IconButton } from "@/subframe/components/IconButton";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { removeNotification } from "../redux/reducers/notificationSlice";
import { useEffect } from "react";

function GlobalNotification() {
  const dispatch = useDispatch();
  const notifications = useSelector(
    (state: RootState) => state.notifications.queue
  );

  useEffect(() => {
    if (notifications.length > 0) {
      const timers = notifications.slice(0, 3).map((notification) =>
        setTimeout(() => {
          dispatch(removeNotification(notification.id));
        }, 5000)
      );

      return () => timers.forEach(clearTimeout);
    }
  }, [notifications, dispatch]);

  const typeClasses = {
    success:
      "border border-success-500/40 bg-neutral-100 shadow-md",
    info: "border border-warning-500/45 bg-neutral-100 shadow-md",
    error: "border border-error-500/45 bg-neutral-100 shadow-md",
  };

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[9999] w-[90%] max-w-md flex flex-col gap-2">
      {notifications.slice(0, 3).map(({ id, type, title, message, icon }) => (
        <div
          key={id}
          className={`flex flex-col items-start gap-2 rounded-md border border-solid ${typeClasses[type]} pl-4 pr-3 py-3 shadow-xl transition-all duration-500 ease-out transform opacity-100 animate-slide-in`}
        >
          <div className="flex w-full items-center gap-4">
            <SubframeCore.Icon
              className="text-heading-3 font-heading-3 text-default-font shrink-0"
              name={icon as SubframeCore.IconName}
            />
            <div className="flex grow shrink-0 basis-0 flex-col items-start gap-0.5 min-w-0">
              <span className="w-full whitespace-pre-wrap text-body-bold font-body-bold text-default-font">
                {title}
              </span>
              <span className="w-full whitespace-pre-wrap text-caption font-caption text-subtext-color">
                {message}
              </span>
            </div>
            <div className="flex items-center justify-end gap-1">
              <IconButton
                icon="FeatherX"
                onClick={() => dispatch(removeNotification(id))}
                className="transition-opacity duration-300 opacity-70 hover:opacity-100"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default GlobalNotification;

// Notification types
//type is required
//"success" | "info" | "error";
//tile is required
// "Changes saved successfully" | "Limit reached" | "Connection Error"
//message is optional
// "" | "Please add credit to continue" | "Unable to connect to WhatsApp Business API. Please check your credentials and try again."
//icon is required
// "FeatherCheckCircle" | "FeatherCoins" | "FeatherAlertTriangle"
//id is required
// Date.now() | Date.now() + 56456 | Date.now() + 867654

// all icon name:
// FeatherCheckCircle
// FeatherMailCheck
// FeatherCheckCircle2
// FeatherCheck
// FeatherCoins
// FeatherActivitySquare
// FeatherActivity
// FeatherAlarmPlus
// FeatherAlertTriangle